/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirmwareLookupTableUpdate
 */
export interface FirmwareLookupTableUpdate {
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    latest_app_version_android: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    latest_app_version_ios: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    latest_firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    current_manufacturing_firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    minimum_app_version_android: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    minimum_app_version_ios: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareLookupTableUpdate
     */
    prototype_firmware_version: string;
}

/**
 * Check if a given object implements the FirmwareLookupTableUpdate interface.
 */
export function instanceOfFirmwareLookupTableUpdate(value: object): value is FirmwareLookupTableUpdate {
    if (!('latest_app_version_android' in value) || value['latest_app_version_android'] === undefined) return false;
    if (!('latest_app_version_ios' in value) || value['latest_app_version_ios'] === undefined) return false;
    if (!('latest_firmware_version' in value) || value['latest_firmware_version'] === undefined) return false;
    if (!('current_manufacturing_firmware_version' in value) || value['current_manufacturing_firmware_version'] === undefined) return false;
    if (!('minimum_app_version_android' in value) || value['minimum_app_version_android'] === undefined) return false;
    if (!('minimum_app_version_ios' in value) || value['minimum_app_version_ios'] === undefined) return false;
    if (!('prototype_firmware_version' in value) || value['prototype_firmware_version'] === undefined) return false;
    return true;
}

export function FirmwareLookupTableUpdateFromJSON(json: any): FirmwareLookupTableUpdate {
    return FirmwareLookupTableUpdateFromJSONTyped(json, false);
}

export function FirmwareLookupTableUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareLookupTableUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'latest_app_version_android': json['latest_app_version_android'],
        'latest_app_version_ios': json['latest_app_version_ios'],
        'latest_firmware_version': json['latest_firmware_version'],
        'current_manufacturing_firmware_version': json['current_manufacturing_firmware_version'],
        'minimum_app_version_android': json['minimum_app_version_android'],
        'minimum_app_version_ios': json['minimum_app_version_ios'],
        'prototype_firmware_version': json['prototype_firmware_version'],
    };
}

export function FirmwareLookupTableUpdateToJSON(json: any): FirmwareLookupTableUpdate {
    return FirmwareLookupTableUpdateToJSONTyped(json, false);
}

export function FirmwareLookupTableUpdateToJSONTyped(value?: FirmwareLookupTableUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latest_app_version_android': value['latest_app_version_android'],
        'latest_app_version_ios': value['latest_app_version_ios'],
        'latest_firmware_version': value['latest_firmware_version'],
        'current_manufacturing_firmware_version': value['current_manufacturing_firmware_version'],
        'minimum_app_version_android': value['minimum_app_version_android'],
        'minimum_app_version_ios': value['minimum_app_version_ios'],
        'prototype_firmware_version': value['prototype_firmware_version'],
    };
}

